module.exports = __webpack_public_path__ + "img/loginimg.42f9a81b.png";